import React from "react";

const MemberConduct = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        C.
        <span className="text-[#01A7D1] "> MEMBER CONDUCT</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. Prohibitions on Submitted Content
        </h1>
        You shall not upload, post, transmit, transfer, disseminate, distribute,
        or facilitate distribution of any content, including text, images,
        video, sound, data, information, or software, to any part of the
        Platform, including your profile ("Profile") or the posting of any
        opinions or reviews in connection with the Platform or the Services
        ("Feedback") (all of the foregoing content is sometimes collectively
        referred to herein as "Submitted Content" and the posting of Submitted
        Content is sometimes referred to as a "Posting" or as "Postings") that:
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        misrepresents the source of anything you post, including impersonation
        of another individual or entity or any false or inaccurate biographical
        information; provides or create links to external sites that violate the
        Terms of Use; is intended to harm or exploit any individual under the
        age of 18 ("Minor") in any way; is designed to solicit, or collect
        personally identifiable information of any female or minor, including,
        but not limited to, name, email address, home address, phone number, or
        the name of his or her school.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        invades anyone's privacy by attempting to harvest, collect, store, or
        publish private or personally identifiable information, such as names,
        email addresses, phone numbers, passwords, account information, credit
        card numbers, home addresses, or other contact information without their
        knowledge and willing consent.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        contains falsehoods or misrepresentations that could damage Yostel or
        any third party;
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        is pornographic, harassing, hateful, illegal, obscene, defamatory,
        libellous, slanderous, threatening, discriminatory, racially, culturally
        or ethnically offensive; incites, advocates, or expresses pornography,
        obscenity, vulgarity, profanity, hatred, bigotry, racism, or gratuitous
        violence; encourages conduct that would be considered a criminal
        offense, give rise to civil liability or violate any law; promotes
        racism, hatred or physical harm of any kind against any group or
        individual; contains nudity, violence or inappropriate subject matter;
        or is otherwise inappropriate.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        is copyrighted, protected by trade secret or otherwise subject to
        third-party proprietary rights, including privacy and publicity rights,
        unless you are the owner of such rights or have permission from the
        rightful owner to post the material and to grant Yostel all of the
        license rights granted herein.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        contains or promotes an illegal or unauthorized copy of another person's
        copyrighted work, such as pirated computer programs or links to them,
        information to circumvent manufacture installed copy-protection devices,
        pirated music or links to pirated music files, or lyrics, guitar tabs or
        sheet music, works of art, teaching tools, or any other item the copy,
        display, use, performance, or distribution of which infringes on
        another's copyright, intellectual property right, or any other
        proprietary right.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        is intended to threaten, stalk, defame, defraud, degrade, victimize, or
        intimidate an individual or group of individuals for any reason on the
        basis of age, gender, disability, ethnicity, sexual orientation, race,
        or religion; or to incite or encourage anyone else to do so.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        intends to harm or disrupt another user's computer or would allow others
        to illegally access software or bypass security on Platforms or servers,
        including but not limited, to spamming; impersonates, uses the identity
        of, or attempts to impersonate a Yostel employee, agent, manager, host,
        another user, or any other person though any means.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        advertises or solicits a business not related to or appropriate for the
        Platform (as determined by Yostel in its sole discretion).
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        contains or could be considered "junk mail", "spam", "chain letters",
        "pyramid schemes", "affiliate marketing", or unsolicited commercial
        advertisement.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        contains advertising for ponzi schemes, discount cards, credit
        counselling, online surveys or online contests.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        distributes or contains viruses or any other technologies that may harm
        Yostel, or the interests or property of Yostel users.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        contains links to commercial services or Platforms, except as allowed
        pursuant to the Terms of Use; is non-local or irrelevant content.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        contains identical content to other open Postings you have already
        posted; or uses any form of automated device or computer program that
        enables the submission of Postings without the express written consent
        of Yostel.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Discriminatory Postings: Indian laws prohibit any preference, limitation
        or discrimination based on race, colour, religion, sex, national origin,
        age, handicap or other protected class. Yostel will not knowingly accept
        any Posting which is in violation of the law. Yostel has the right, in
        its sole discretion and without prior notice to you; to immediately
        remove any posting that discriminates or is in any way in violation of
        any law.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. Prohibitions with respect to Services
        </h1>
        While using the Platform, you shall not:
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        post content or items in any inappropriate category or areas on the
        Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        violate any laws, third-party rights, Account policies, or any provision
        of the Terms of Use, such as the prohibitions described above.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        fail to deliver payment for Services purchased by you.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        circumvent or manipulate the fee structure, the billing process, or fees
        owed to Yostel; post false, inaccurate, misleading, defamatory, or
        libellous content (including personal information about any Platform
        user).
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        take any action that may undermine the Feedback or ratings systems (such
        as displaying, importing or exporting Feedback information off of the
        Platform or using it for purposes unrelated to the Platform).
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          3. Feedback
        </h1>
        As a participant in the Platform, you agree to use careful, prudent, and
        good judgment when leaving Feedback. Sanctions for Inappropriate Use of
        Feedback. If you violate any of the above-referenced rules in connection
        with leaving Feedback, Yostel, in its sole discretion, may take any of
        the following actions: (i) cancel your Feedback or any of your Postings;
        (ii) limit your Account privileges; (iii) suspend your Account; and/or
        (iv) decrease your status earned via the Feedback page.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Reporting Inappropriate Use of Feedback. You may contact Yostel
        regarding any inappropriate use of Feedback via-email at
        ping@Yostelliving.com.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Resolving Disputes in Connection with Feedback. In the event of any
        dispute between users of the Platform concerning Feedback, Yostel shall
        be the final arbitrator of such dispute. Further,
        <span className="text-lg font-medium">
          {" "}
          IN THE EVENT OF ANY DISPUTE BETWEEN USERS OF THE PLATFORM CONCERNING
          FEEDBACK, Yostel HAS THE RIGHT, IN ITS SOLE AND ABSOLUTE DISCRETION,
          TO REMOVE SUCH FEEDBACK OR TAKE ANY ACTION IT DEEMS REASONABLE WITHOUT
          INCURRING ANY LIABILITY THEREFROM.
        </span>
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        The foregoing lists of prohibitions provide examples and are not
        complete or exclusive. Yostel reserves the right to (a) terminate your
        access to your Account, your ability to post to this Platform (or the
        Services) and (b) refuse, delete or remove, move or edit the content, in
        whole or in part, of any Postings; with or without cause and with or
        without notice, for any reason or no reason, or for any action that
        Yostel determines is inappropriate or disruptive to this Platform or to
        any other user of this Platform and/or Services. Yostel reserves the
        right to restrict the number of emails or other messages that you are
        allowed to send to other users to a number that Yostel deems appropriate
        in Yostel's sole discretion. Yostel may report to law enforcement
        authorities any actions that may be illegal, and any reports it receives
        of such conduct. When legally required or at Yostel's discretion, Yostel
        will cooperate with law enforcement agencies in any investigation of
        alleged illegal activity on this Platform or on the Internet. Yostel
        does not and cannot review every Posting posted to the Platform. These
        prohibitions do not require Yostel to monitor, police or remove any
        Postings or other information submitted by you or any other user.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          4. Prohibitions with respect to Platform
        </h1>
        You acknowledge and agree that you shall comply with the following
        policies (the "Account Policies"):
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You will not copy or distribute any part of the Platform in any medium
        without Yostel's prior written authorization.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You will provide true, accurate, current and complete information while
        creating your Account and you shall maintain and update such information
        during the term of this Agreement so that it will remain accurate, true,
        current and complete.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You shall not use any automated system, including but not limited to,
        "robots," "spiders," "offline readers," "scrapers," etc., to access the
        Platform for any purpose without Yostel's prior written approval.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You shall not in any manner i.e. manual or automated collect users
        information, including but not limited to, names, addresses, phone
        numbers, or email addresses, copying copyrighted text, or otherwise
        misuse or misappropriate Platform information or content, including but
        not limited to, use on a "mirrored", competitive, or third-party site.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You shall not in any way transmit multiple request messages to the
        Yostel servers, or any server of a Yostel subsidiary or affiliate, in a
        given period of time than a human can reasonably produce in the same
        period by using a conventional online web browser; provided, however,
        that the operators of public search engines may use spiders or robots to
        copy materials from the site for the sole purpose of creating publicly
        available searchable indices of the materials, but not caches or
        archives of such material. Yostel reserves the right to revoke these
        exceptions either generally or in specific cases.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You shall not take any action that (i) unreasonably encumbers or, in
        Yostel's sole discretion, may unreasonably encumber the Platform's
        infrastructure; (ii) interferes or attempts to interfere with the proper
        working of the Platform’s or any third-party participation in the
        Platform; or (iii) bypasses Yostel's measures that are used to prevent
        or restrict access to the Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You agree not to collect or harvest any personally identifiable data,
        including without limitation, names or other Account information, from
        the Platform, nor to use the communication systems provided by the
        Platform for any commercial solicitation purposes.
      </p>
    </div>
  );
};

export default MemberConduct;
